module.exports = __webpack_public_path__ + "static/media/print-gray.50f8e895.svg";